<template>
  <div
    v-if="addCollectionSearchDisplayType === 'addCollectionGrid' || display === 'queue'"
    :id="'item' + resource.id"
    ref="grid"
    class="marketing-item-container c"
    @mouseover="handleHover(resource)"
    @mouseleave="handleHoverLeave(resource)"
    @click="handleSelectedItem(resource)"
  >
    <div class="image">
      <v-img
        :src="resource.imageUri"
        max-width="200"
        max-height="50"
        alt="Download"
      />
    </div>
    <div class="label">
      {{ resource.name }}
    </div>
  </div>
  <div
    v-if="addCollectionSearchDisplayType === 'addCollectionList'"
    :id="'item' + resource.id"
    ref="list"
    class="marketing-item-list-container c"
    @mouseover="handleHover(resource)"
    @mouseleave="handleHoverLeave(resource)"
    @click="handleSelectedItem(resource)"
  >
    <div class="left-side">
      <div class="image-list">
        <img
          :src="resource.imageUri"
          alt="image"
          class="list-image"
        >
      </div>
      <div class="label">
        {{ resource.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia/dist/pinia';
import { gsap } from 'gsap';
// import SelectionMarker from "@/components/libraries/search/marketingItem/SelectionMarker";
// import Axios from "axios";
import { useRMTStore } from '@/store/RMTStore';

export default {
	components: {
		// SelectionMarker,
		// SavedMarker
	},
	props: [
		'num',
		'resource',
		'display',
		'type',
		'mode'
	],
	data () {
		return {
			selectedItems: [],
		};
	},
	mounted () {
		if (this.RMTStore.collectionMode != 0) {
			this.RMTStore.createdCollectionItems.forEach((item) => {
				const itemId = '#item' + item.id;
				gsap.to(itemId, {
					border: '1px solid black'
				});
			});
		}
		if (this.$props.resource.id === undefined)
			{ this.$props.resource.id = this.$props.num; }
	},
	computed: {
		...mapStores(useRMTStore),
		addCollectionSearchDisplayType () {
			return this.RMTStore.getAddCollectionSearchDisplayType;
		}
	},
	methods: {
		handleHover (resource) {
			if (!this.RMTStore.createdCollectionItems.includes(resource)) {
				const itemId = '#item' + resource.id;
				gsap.to(itemId, {
					borderColor: 'black',
					backgroundColor: '#fafafa',
					duration: .2
				});
			}
		},
		handleHoverLeave (resource) {
			if (!this.RMTStore.createdCollectionItems.includes(resource)) {
				const itemId = '#item' + resource.id;
				gsap.to(itemId, {
					borderColor: '#ffffff',
					backgroundColor: '#ffffff',
				});
			}
		},
		removeObjectWithId (arr, id) {
			const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
			if (objWithIdIndex > -1) { arr.splice(objWithIdIndex, 1); }
			return arr;
		},
		handleSelectedItem (resource) {
			const itemId = '#item' + resource.id;
			const addItemId = 'addItem' + resource.id;
			// checks whether resouces is already in the array. If so get rid of it.
			if (this.RMTStore.createdCollectionId.includes(resource.id)) {
				// const itemIndex = this.RMTStore.createdCollectionId.indexOf(resource.id);
				const filterItemId = this.RMTStore.createdCollectionId.filter(function (
					element
				) {
					return element != resource.id;
				});
				const filterItems = this.RMTStore.createdCollectionItems.filter(
					function (element) {
						return element.id != resource.id;
					}
				);

				this.RMTStore.createdCollectionId = filterItemId;
				this.RMTStore.createdCollectionItems = filterItems;
				gsap.to(itemId, {
					border: 'none',
				});
				if (document.getElementById(addItemId) != null) {
					document.getElementById(addItemId).remove();
				}
			} else {
				gsap.to(itemId, {
					border: '1px solid black',
				});
				// For count of what is selected and not.
				this.RMTStore.isCollectionItemsChanged = this.RMTStore.isCollectionItemsChanged ? false : true;
				this.RMTStore.createdCollectionId.push(resource.id);
				this.RMTStore.setCollectionSelectedItems(resource);
			}
		},
	},
};
</script>

<style scoped>
.marketing-item-container {
	user-select: none;
	width: calc(25% - 4px);
	height: 200px;
	padding: 2px 2px 10px;
	margin-bottom: 5px;
	margin-left: 2px;
	margin-right: 2px;
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	cursor: pointer;
	border: 1px solid white;
}
.image {
	height: 50%;
  width: 50%;
  scale: 2;
	pointer-events: none;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 2px 4px 43px -32px #a6b5a6;
}
.label {
	pointer-events: none;
	padding: 10px 10px 10px 10px;
	font-size: 0.8em;
	font-weight: bold;
}
.label-list {
	white-space: nowrap;
}
.download img {
	width: 100%;
	height: 100%;
}
.marketing-item-list-container {
	user-select: none;
	width: 100%;
	padding: 2px;
	margin-bottom: 5px;
	margin-left: 2px;
	margin-right: 2px;
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	border: 1px solid #f5f5f5;
}
.left-side {
	height: 55px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.right-side {
	display: flex;
	align-items: center;
	justify-content: center;
}
.selectionMarkerList {
	margin-left: 15px;
	margin-right: 15px;
}
.list-image {
	object-fit: contain;
	height: 55px;
}
.image-list {
	height: 55px;
}
</style>
